<ng-container *ngIf="loading && isWebComponent">
	<cdx-wapple-loading></cdx-wapple-loading>
</ng-container>

<p
	class="text--center emptyMessage"
	*ngIf="!products?.length && !loading && emptymessage"
	attr.aria-level="3"
	attr.aria-role="heading"
>
	{{ emptymessage }}
</p>

<ng-container *ngFor="let product of products; let i = index; trackBy: trackByProductSkuAndSelectedPurchasingUnit">
	<ng-container *ngIf="isLayoutGrid; else productStampList">
		<ng-container [ngSwitch]="product?.type">
			<cdx-cta
				[cta]="product"
				(clickEmitter)="handleClick(product)"
				(initEmitter)="handleImpression(product, isCartologyGAMSessionGroup ? product.additionalClassNames : '')"
				*ngSwitchCase="'PromoTile'"
				[class]="isCartologyGAMSessionGroup ? product.additionalClassNames : ''"
			></cdx-cta>
				<product-content-in-grid
					[content]="product"
					[gridPosition]="productIndexOffset + gridPositions[i]"
					[cppItemCount]="cppItemCount"
					(advertisementClick)="handleClickContentInGridCarousel(product)"
					(init)="handleImpressionContentInGridCarousel(product)"
					[cdxTrackImpression]="productImpressionArgs[i]"
					[target]="target"
					*ngSwitchCase="'PromotionalCarousel'"
				></product-content-in-grid>
			<ng-container *ngSwitchDefault>
				<cdx-card *ngIf="isProductVisible(product.sku) && !shouldHideOutOfStockProduct(product)" [ngClass]="{'cdx-card-cup-adjustment': isCPUUIAdjustimentOn}">
					<product-stamp-grid
						[canRemoveFromList]="canremove"
						[listId]="listid"
						[listName]="listName"
						[isShopper]="isShopper"
						[isBoostOfferActivatedFromState]="isBoostOfferActivated(product.productTag) | async"
						[isLoggedIn]="isLoggedIn"
						[product]="product"
						[position]="productIndexOffset + gridPositions[i]"
						[cppItemCount]="cppItemCount"
						[uniqueid]="product.sku"
						[sourceCarousel]="name"
						[listType]="listtype"
						(visiblityChange)="handleVisibleOnChange(product.sku, $event)"
						[cdxTrackImpression]="productImpressionArgs[i]"
						[department]="department"
						[aisle]="aisle"
						[shelf]="shelf"
						[target]="target"
						(click)="handleCppClicked(product, gridPositions[i])"
						[showBoughtBefore]="showBoughtBefore(productIndexOffset + gridPositionsForBoughtBefore[i])"
						[hideUnavailableProductPrice]="hideUnavailableProductPrice"
					>
					</product-stamp-grid>
				</cdx-card>
			</ng-container>
		</ng-container>
	</ng-container>
	<ng-template #productStampList>
		<product-stamp-list
			[isShopper]="isShopper"
			[isLoggedIn]="isLoggedIn"
			[product]="product"
			[department]="department"
			[uniqueid]="product.sku"
			[sourceCarousel]="name"
			[isExistingSkuWhenChangingOrder]="isExistingSkuWhenChangingOrder"
			[showChangedPriceTutorial]="showChangedPriceTutorial(i)"
			(removeProductEmitter)="removeProduct($event)"
			(updateProductEmitter)="updateAffectedProducts($event)"
			(allowSubstitutesProductEmitter)="allowSubstitutesProduct($event)"
			(disallowSubstitutesProductEmitter)="disallowSubstitutesProduct($event)"
		>
		</product-stamp-list>
	</ng-template>
</ng-container>
